import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { imgUrl } from "../lib/api";
import { FadeUp } from "../components/Reveal";

export default function About({ config }) {
  const paragraphs = (config?.about_long || "").split("\n\n").filter(Boolean);

  return (
    <div className="pt-32 sm:pt-28 px-5 sm:px-8 pb-20" data-testid="about-page">
      <FadeUp>
        <p className="text-[10px] font-bold tracking-[0.3em] text-smoke mb-3">THE ARTIST BEHIND ARTILLERY KDP</p>
        <h1 className="font-display text-6xl sm:text-8xl tracking-wide leading-[0.9]" data-testid="about-title">
          KENNY<br />DEPRINCE<span className="text-pink">.</span>
        </h1>
      </FadeUp>

      <FadeUp className="mt-10 max-w-3xl">
        {config?.artist_photo ? (
          <div className="border border-white/15 overflow-hidden aspect-[3/2]" data-testid="about-photo-portrait">
            <img src={imgUrl(config.artist_photo)} alt="Kenny DePrince — artist, ARTILLERY KDP"
              className="w-full h-full object-cover object-left" loading="lazy" draggable={false} />
          </div>
        ) : (
          <div className="aspect-[3/2] border border-dashed border-white/20 flex items-center justify-center p-3" data-testid="about-photo-portrait">
            <span className="text-[10px] tracking-[0.25em] text-smoke text-center leading-relaxed">ARTIST PORTRAIT<br />COMING SOON</span>
          </div>
        )}
      </FadeUp>

      <div className="mt-10 max-w-xl space-y-5">
        {paragraphs.map((p, i) => (
          <FadeUp key={i} delay={Math.min(i * 0.05, 0.25)}>
            <p className={`leading-relaxed ${i === 0 ? "text-lg text-bone font-semibold" : "text-base text-bone/80"}`} data-testid={`about-paragraph-${i}`}>{p}</p>
          </FadeUp>
        ))}
      </div>

      <FadeUp className="mt-10 flex flex-wrap gap-2" data-testid="about-chips">
        {["STENCIL ART", "POP ART", "STREET INFLUENCE", "PHILADELPHIA", "ORIGINALS", "LIMITED EDITIONS", "MURALS"].map((c) => (
          <span key={c} className="text-[10px] font-bold tracking-[0.2em] border border-white/15 text-bone/70 px-3 py-2">{c}</span>
        ))}
      </FadeUp>

      <FadeUp className="mt-12 flex flex-wrap gap-3">
        <Link to="/art" data-testid="about-see-work" className="h-12 px-7 bg-bone text-ink text-sm font-extrabold tracking-[0.18em] flex items-center gap-2 hover:bg-pink hover:text-white transition-colors duration-200">
          SEE THE WORK <ArrowRight size={16} />
        </Link>
        <Link to="/contact" data-testid="about-contact" className="h-12 px-7 border border-white/25 text-sm font-extrabold tracking-[0.18em] flex items-center hover:border-pink hover:text-pink transition-colors duration-200">
          CONTACT KENNY
        </Link>
      </FadeUp>
    </div>
  );
}
